/** What a receiver does with each received row of a sales-order return (DLV-D17); the API maps it to `ReturnDisposition`. */
export const RETURN_OUTCOMES = ['RESTOCK', 'QUARANTINE', 'DESTROY'];
//# sourceMappingURL=return-outcome.js.map